import {
    type GetApiBookingIdQueryKey,
    type GetApiBookingIdQueryResponse,
    type ResponseErrorConfig,
    useGetApiBookingId,
} from '@barbershop/api/customer'
import type { QueryObserverOptions } from '@tanstack/react-query'

interface UseFetchBookingByIdProps {
    bookingId?: number
    branchId: number
    query?: Partial<
        QueryObserverOptions<
            GetApiBookingIdQueryResponse,
            ResponseErrorConfig<Error>,
            GetApiBookingIdQueryResponse,
            GetApiBookingIdQueryResponse,
            GetApiBookingIdQueryKey
        >
    >
}

export const useFetchBookingById = ({ bookingId, branchId, query }: UseFetchBookingByIdProps) => {
    const enabled = bookingId != null && (query?.enabled ?? true)

    const { data, error, isLoading } = useGetApiBookingId(
        bookingId,
        { branch_id: branchId },
        {
            query: {
                ...query,
                enabled,
            },
        }
    )

    return {
        booking: data,
        error,
        isLoading,
    }
}
